// test1540
(1540 && 0);
